export const publicRoutes = [
  {
    path: '/summary/:status/:hash',
    name: 'Summary',
    component: () => import('@/layouts/summary/Index.vue'),
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('@/layouts/errors/PageNotFound.vue'),
  },
]
